import Permissoes from '../permissoes';

export default function usePermissoes() {
  let permissoes = [];
  try {
    permissoes = JSON.parse(localStorage.getItem('permissoes')) || [];
  } catch {
    permissoes = [];
  }

  return {
    permissoes,
    hasPermission: (nome) => !nome || permissoes.includes(nome),
    isTI: permissoes.includes(Permissoes.TI),
  };
}
